module.exports = __webpack_public_path__ + "98f8625aeeb6a210c9baa374558d7845.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-420.webp.png
// module id = 216
// module chunks = 0